import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const TestPreparationService = {
  getList: async () => {
    const response = await apiService.get("/testpreparations", {
      params: {
        page: 1,
        pageSize: 20,
      },
    });
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/testpreparations/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(`/testpreparations/slug?slug=${id}`);
    return response.data;
  },
};

export default TestPreparationService;
